var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"95,17 83,5 50,38 17,5 5,17 38,50 5,83 17,95 50,62 83,95 95,83 62,50 "}));
}

Close.defaultProps = {"height":"100px","width":"100px","fill":"#000000","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = Close;

Close.default = Close;
